import './App.css';
import Cabecera from '@componentes/Cabecera/Cabecera';
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Aparcamientos from '@componentes/Aparcamientos/Aparcamientos';
import EstadoTrafico from '@componentes/EstadoTrafico/EstadoTrafico';
import Incidencias from '@componentes/Incidencias/Incidencias';
import Footer from '@componentes/Footer/Footer';
// import BannerRotativo from '@componentes/BannerRotativo/BannerRotativo';
import EnlacesInteres from '@componentes/EnlacesInteres/EnlacesInteres';
import EnlacesSuperior from '@componentes/EnlacesSuperior/EnlacesSuperior';
import Principal from '@componentes/Principal/Principal';
import PaginaMapa from '@componentes/PaginaMapa/PaginaMapa';

function App() {
  return (
    <div id='container'>
      <Router>
        <div className='encabezado-principal'>
          <EnlacesSuperior />
          <Cabecera />
          {/* <BannerRotativo /> */}
        </div>
        <main>
          <Routes>
            <Route path="/" element={<Principal />} />
            <Route path="/aparcamientos" element={<Aparcamientos />} />
            <Route path="/estado" element={<EstadoTrafico />} />
            <Route path="/incidencias" element={<Incidencias />} />
            <Route path="/enlaces" element={<EnlacesInteres />} />
            <Route path="/mapa" element={<PaginaMapa />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
